export const TOAST_FEATURE_KEY = 'toast';
